<template>
  <div class="dataloggerManage">
    <div class="section">
      <div class="search">
        <div class="searchLeft">
          <!-- 添加api开放key -->
          <button
            class="button-solid button buttonDeviceJurisdiction"
            @click="addedManufacturerCodeCilck"
          >
            <span class="iconfont icon-add"></span>
          </button>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        :data="dataloggerLog"
        border
        stripe
        height="100%"
        :row-style="{ height: 0 }"
        :cell-style="{ padding: 0 }"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }"
        v-loading="loadingDatalogger"
        element-loading-spinner="el-icon-loading"
        class="tablemain tableloding"
      >
        <el-table-column :label="this.$t('settingalarm.list')" fixed type="index" width="70"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" :label="$t('keyList.companyName')">
          <template slot-scope="scope">
            <span>{{scope.row.companyname ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('keyList.version_number')">
          <template slot-scope="scope">
            <span>{{scope.row.version ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('keyList.client')">
          <template slot-scope="scope">
            <span>{{scope.row.client ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('keyList.domainName')">
          <template slot-scope="scope">
            <span>{{scope.row.domain ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('keyList.contact_information')">
          <template slot-scope="scope">
            <span>{{scope.row.contactinformation ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('keyList.key')">
          <template slot-scope="scope">
            <span>{{scope.row.key ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('keyList.describe')">
          <template slot-scope="scope">
            <span>{{scope.row.desc ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('keyList.unseal')">
          <template slot-scope="scope">
            <span v-if="scope.row.enable" >{{$t('settingalarm.Yes') }}</span>
            <span v-else>{{$t('settingalarm.No') }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="tablebottom">
        <!-- 批量占位 -->
        <div class style="margin-left:10px;"></div>
        <!-- 分页 -->
        <el-pagination
          class="pagination"
          background
          @size-change="getDataloggerLog(true)"
          @current-change="() => getDataloggerLog()"
          :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total"
          popper-class="select-page"
        >
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
      <!-- 新增添加api开放key -->
      <!-- :title="$t('account.createAccount')" -->
      <account-dialog
        title="添加api开放key"
        :visible.sync="showCreatnewcountDialog"
        width="550px"
        :class="{ 'showDialog': showCreatnewcountDialog, 'hideDialog': !showCreatnewcountDialog }"
        noFooter
      >
        <el-form
          ref="creatForm"
          :model="addedManufacturerCodeform"
          class="chuangjian grid"
          slot="content"
          :rules="creatRules"
        >
          <el-form-item :label="$t('keyList.companyName')" prop="companyname">
            <el-input v-model.trim="addedManufacturerCodeform.companyname" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('keyList.domainName')" prop="domain">
            <el-input v-model.trim="addedManufacturerCodeform.domain" clearable type="text"></el-input>
          </el-form-item>
          <el-form-item :label="$t('keyList.version_number')" prop="version">
            <el-input v-model.trim="addedManufacturerCodeform.version" clearable type="text"></el-input>
          </el-form-item>
          <el-form-item :label="$t('keyList.contact_information')" prop="contactinformation">
            <el-input
              v-model.trim="addedManufacturerCodeform.contactinformation"
              clearable
              type="text"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('keyList.platform')" prop="client">
            <el-select v-model="addedManufacturerCodeform.client">
              <el-option label="Web" value="web"></el-option>
              <el-option label="Android" value="android"></el-option>
              <el-option label="ios" value="ios"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="key" prop="key">
            <el-input
              v-model.trim="addedManufacturerCodeform.key"
              clearable
              type="text"
              :placeholder="$t('keyList.keyTips2')"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('keyList.describe')" prop="desc">
            <el-input v-model.trim="addedManufacturerCodeform.desc" clearable type="text"></el-input>
          </el-form-item>
          <el-form-item :label="$t('keyList.unseal')" prop="enable">
            <el-select v-model="addedManufacturerCodeform.enable">
              <el-option :label="$t('settingalarm.Yes')" value="true"></el-option>
              <el-option :label="$t('settingalarm.No')" value="false"></el-option>
            </el-select>
          </el-form-item>
          <!-- Grid占位 -->
          <div></div>
          <div style="text-align:right;">
            <button
              type="button"
              class="btn btn-dark"
              @click="creatnewcount"
            >{{ $t('account.submit') }}</button>
          </div>
        </el-form>
      </account-dialog>
    </div>
  </div>
</template>
    <script>
import dataloggerDialog from "@/components/dialognew/dataloggernew";
import accountDialog from "@/components/dialognew";
import Vue from "vue";
import { mapGetters } from "vuex";
import { i18n } from "@/i18n";
export default {
  components: {
    dataloggerDialog,
    accountDialog
  },
  data() {
    return {
      // 分页
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      },
      addedManufacturerCodeform: {
        companyname: "",
        domain: "",
        version: "",
        contactinformation: "",
        client: "Web",
        key: "",
        desc: "",
        enable: "true"
      },
      loadingDatalogger: false,
      dataloggerLog: [],
      showCreatnewcountDialog: false,
      creatRules: {
        companyname: [
          {
            required: true,
            message: this.$t("keyList.companyNameTips"),
            trigger: "change"
          }
        ],
        domain: [
          {
            required: true,
            message: this.$t("keyList.domainNameTips"),
            trigger: "change"
          }
        ],
        version: [
          {
            required: true,
            message: this.$t("keyList.version_numberTips"),
            trigger: "change"
          }
        ],
        contactinformation: [
          {
            required: true,
            message: this.$t("keyList.contact_informationTips"),
            trigger: "change"
          }
        ],
        client: [
          {
            required: true,
            message: this.$t("keyList.clientTips"),
            trigger: "change"
          }
        ],
        key: [
          {
            required: true,
            message: this.$t("keyList.keyTips"),
            trigger: "change"
          },
          {
            min: 16,
            max: 16,
            message: this.$t("keyList.keyTips2"),
            trigger: "blur"
          }
        ],
        desc: [
          {
            required: true,
            message: this.$t("keyList.describeTips"),
            trigger: "change"
          }
        ],
        enable: [
          {
            required: true,
            message: this.$t("keyList.unsealTips"),
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getDataloggerLog();
  },
  methods: {
    // 列表数据
    getDataloggerLog() {
      this.loadingDatalogger = true;
      let params = {
        i18n: this.$lang.currentLang,
        page: this.pagination.currentPage - 1,
        pagesize: this.pagination.pagesize
      };
      this.$request
        .get("adminQueryCompanyKey", params)
        .then(res => {
          this.loadingDatalogger = false;
          if (res.err == 0) {
            this.dataloggerLog = res.dat.item;
            this.pagination.total = res.dat.totalCount;
          } else {
            this.dataloggerLog = [];
          }
        })
        .catch(err => {
          this.loadingDatalogger = false;
          this.dataloggerLog = [];
        });
    },
    // 新增添加api开放key按钮
    addedManufacturerCodeCilck() {
      this.$refs.creatForm.resetFields();
      this.showCreatnewcountDialog = true;
      this.addedManufacturerCodeform = {
        companyname: "",
        domain: "",
        version: "",
        contactinformation: "",
        client: "Web",
        key: "",
        desc: "",
        enable: "true"
      };
    },
    // 新增添加api开放key确认按钮
    creatnewcount() {
      this.$refs.creatForm.validate(valid => {
        if (!valid) return false;
        let params = {
          ...this.addedManufacturerCodeform,
          i18n: this.$lang.currentLang
        };
        this.$request.get("adminAddCompanyKey", params).then(res => {
          if (res.err == 0) {
            this.showCreatnewcountDialog = false;
            this.getDataloggerLog();
            this.$message.success(this.$t("datalogger.add_suc"));
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
      });
    }
  }
};
</script>
    <style lang="less" scoped>
@import url("../../../../assets/css/mixin.less");

.dataloggerManage {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px;
  // background-color: rgb(34, 45, 53);
  overflow: auto;
  .grid {
    grid-row-gap: 22px;
  }
  .chuangjian,
  .bianji,
  .chongzhi {
    .juxing {
      display: inline-block;
      width: 100px;
      height: 10px;
      border: 0px solid #fff;
      margin-left: 5px;
    }

    .inputlo {
      margin-bottom: -16px;
      height: 20px;
    }

    .input_spans,
    .pwd_span,
    .email_span,
    .phone_span,
    .confpwd_span {
      height: 20px;
      line-height: 20px;
      color: #f56c6c;
      font-size: 12px;
    }

    .input_span {
      height: 20px;
      line-height: 20px;
    }

    .sucess {
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: #999;
      // font-family: "Microsoft YaHei";
    }

    // /deep/ .el-form-item__error {
    //   display: none;
    // }
  }
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .ico-recharge {
    background: url(../../../../assets/img/general/Icon_Recharge.png);
  }

  .ico {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    vertical-align: middle;
  }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);
      .searchLeft {
        .buttonDeviceJurisdiction {
          padding: 0 17px 0 12px;
          background-color: @primaryTextColor;
          color: #222d35;
          border-radius: 0;
          span {
            padding-left: 5px;
          }
        }
      }
      .searchRight {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .tool {
          /deep/.el-date-editor.el-input .el-input__prefix {
            right: auto;
            left: 16px;
            font-size: 16px;
            color: #00febb;
          }

          /deep/.el-date-editor.el-input .el-input__inner {
            height: 46px;
            padding-left: 52px;
            background: transparent;
            color: #ffffff;
            border: none;
            border-radius: 0px;
            // border-left: 1px solid #7B8395;
            // border-right: 1px solid #7B8395;
          }

          /deep/.el-date-editor.el-input
            .el-input__suffix
            .el-input__icon:after {
            content: "";
            display: inline-block;
            position: absolute;
            top: 12px;
            right: -2px;
            height: 20px;
            width: 20px;
            background: url(../../../../assets/img/general/Icon_Down_Border.png)
              no-repeat;
            background-size: 100%;
            background-position: center;
          }

          // 时间图标
          /deep/.el-icon-date:before {
            content: "";
            display: inline-block;
            position: absolute;
            top: 12px;
            left: 0px;
            height: 24px;
            width: 24px;
            background: url(../../../../assets/img/general/Icon_Calendar.png)
              no-repeat;
            background-size: 100%;
            background-position: center;
          }

          .datePreNext {
            padding: 0px 16px;
            border-right: 1px solid #7b8395;
            border-left: 1px solid #7b8395;

            /deep/.datepicker {
              margin: 0px;
              // margin-right: 16px;
            }

            /deep/.el-date-editor {
              margin-right: 16px;
            }

            /deep/.el-date-editor.el-input {
              width: 150px;
            }

            /deep/.el-date-editor.el-input .el-input__inner {
              padding: 0px;
              text-align: center;
            }

            //.el-input__prefix,
            //.el-input__suffix
            /deep/.el-input__prefix {
              display: none;
            }

            /deep/.el-input__suffix {
              top: 2px;
              right: 16px;
            }

            .date-icon {
              display: inline-block;
              width: 24px;
              height: 24px;
              background: url(../../../../assets/img/general/Icon_Calendar.png);
              background-size: 100%;
              background-position: center;
              background-repeat: no-repeat;
              vertical-align: middle;
              margin-right: 16px;
            }

            .date-pre {
              background: url(../../../../assets/img/general/Chart_Date_Pre.png);
            }

            .date-next {
              background: url(../../../../assets/img/general/Chart_Date_Next.png);
            }

            .date-btn {
              color: #ffffff;
              cursor: pointer;
              display: inline-block;
              height: 16px;
              width: 16px;
              background-size: 100%;
              background-position: center;
              background-repeat: no-repeat;
              vertical-align: middle;
            }
          }
        }
        .searchAll {
          /deep/.el-input__inner {
            width: 220px;
            padding-left: 10px;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          width: 100%;
          font-size: 14px;
          background: #202d35;
          color: #33ffb6;
          cursor: pointer;
          // border-right: 1px solid #7b8395;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          // line-height: 48px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 15px;
          font-size: 14px;
          background: #202d35;
          color: #7b8395;
          border-left: 1px solid #7b8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }
      }

      .active {
        color: #00febb;
        border-bottom: 2px solid #00febb;
      }

      /deep/.el-select {
        width: 100px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }
      .batch-alert {
        height: 48px;
        line-height: 48px;
      }
    }

    .tableloding {
      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, 0.5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      .operation1 i {
        color: @primaryColorTransparency30;
      }

      // 表格右侧边线
      // /deep/.el-table--border::after,
      // /deep/.el-table--group::after {
      //   width: 0px;
      // }
      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        // border-bottom: none;
      }

      /deep/.el-table__header th > .cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox
        .el-checkbox__input.is-indeterminate
        .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202d35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7b8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2b3842;
          color: #15c491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2b3842;
          color: #7b8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7b8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2b3842;
        color: #7b8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2b3842;
        color: #7b8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }
}
</style>
    <style lang="less">
// #下拉选框#
.select-search-recharge {
  background-color: rgb(34, 45, 53);
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border-radius: 4px;
  border: none;
  padding: 8px 0px;

  .el-select-dropdown__list {
    padding: 0px;
  }

  .el-select-dropdown__item {
    padding: 0px 16px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.hover {
    display: flex;
    align-items: center;
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
  }

  .el-select-dropdown__item.selected {
    padding: 0px 16px;
    background-color: transparent;
    font-weight: normal;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item:hover {
    padding: 0px 16px;
    background: @primaryColorTransparency30;
    color: rgba(255, 255, 255, 1);
  }

  .el-select-dropdown__item.selected .select-label {
    padding: 0px;
  }

  // 对号
  .el-select-dropdown__item.selected:before,
  .el-select-dropdown__item.selected .select-label:before,
  .el-select-dropdown__item.selected.choose-num:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    position: absolute;
    top: 8px;
    right: 16px;
  }

  // 下拉框上传固件按钮
  .upFirewareBtn {
    background: rgba(34, 45, 53, 1);
    border: 1px solid rgba(226, 227, 227, 1);
    border-radius: 6px;
    padding: 6px 30px;
    color: rgba(226, 227, 227, 1);
    font-size: 14px;
    cursor: pointer;
  }
}

.select-search-project {
  .el-select-dropdown__list {
    padding: 0 16px;
  }

  .el-select-dropdown__item {
    height: 40px;
    line-height: 40px;
    box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
  }
}

.selectClearNew {
  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}

// #时间选择器 el-date-picker#
.select-date {
  // 下拉
  &.el-date-picker {
    background: rgba(34, 45, 53, 1);
    border: none;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.48);
  }

  // 切换日 -----
  // 头部切换
  .el-date-picker__header {
    padding: 0px 50px;
  }

  .el-date-picker__header-label {
    color: rgba(238, 236, 241, 1);
  }

  // 前后切换
  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  // 一周
  .el-date-table th {
    color: rgba(238, 236, 241, 1);
    border: none;
  }

  // 日
  .el-date-table td div {
    padding: 0px;
  }

  .el-date-table td.today span {
    color: #00febb;
    font-weight: normal;
  }

  .el-date-table td.available {
    color: rgba(122, 117, 133, 1);
    font-size: 14px;
  }

  .el-date-table td.available:hover {
    color: #00febb;
  }

  .el-date-table td.current:not(.disabled) span {
    width: 30px;
    height: 30px;
    line-height: 26px;
    text-align: center;
    border-radius: 16px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    margin-top: -3px;
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: rgb(60, 56, 68);
    font-size: 16px;
  }

  // 切换月 -----
  .el-date-picker__header--bordered {
    border: none;
  }

  // 月
  .el-month-table td.today .cell {
    color: #00febb;
  }

  .el-month-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 32px;
  }

  .el-month-table td .cell {
    color: #7b8395;
  }

  .el-month-table td .cell:hover {
    color: #00febb;
  }

  // 切换年 -----
  // 年
  .el-year-table td.today .cell {
    color: #00febb;
  }

  .el-year-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 28px;
  }

  .el-year-table td .cell {
    color: #7b8395;
  }

  .el-year-table td .cell:hover {
    color: #00febb;
  }
}
.tablemain.el-table--border::after {
  display: none;
}

.dataloggerManage {
  .scqsbAlert {
    .el-table--border::after,
    .el-table--group::after {
      display: block;
      background-color: #a3a9b5;
    }

    // 弹窗表格右侧边线
    .el-table--border {
      border-right: 1px solid #a3a9b5;
    }

    // 滚动条
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: transparent;
    }

    // 加载数据时遮罩
    .el-loading-mask {
      background-color: transparent;
    }

    .el-loading-spinner i {
      color: @primaryTextColor;
    }
  }
}
</style>
    <style lang="less">
// 日期选择器增加今日快捷
.select-date {
  width: 320px !important;
  padding-top: 10px;

  // 头部
  .el-date-picker__header {
    width: 100%;
    margin: 12px 0px !important;
    padding: 0px 30px !important;
  }

  .el-picker-panel__body-wrapper {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
    align-items: flex-end;

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        // margin-top: 0px;
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }
}
.el-date-table td.disabled div {
  background-color: #222d35 !important;
  color: #606266 !important;
}
.el-year-table td.disabled .cell {
  background-color: #222d35 !important;
}
.el-month-table td.disabled .cell {
  background-color: #222d35 !important;
}
</style>
    